import React, { FunctionComponent, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";

import AlarmRules from "./AlarmRules";


interface IProps {
  siteId: string;
  ns?: string;
  name?: string;
  onClosed?: () => void;
}


const AlarmGroupDetail: FunctionComponent<IProps> = ({
  siteId,
  ns,
  name,
  onClosed,
}) => {
  const intl = useIntl();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const textColor = useColorModeValue("black", "white");
  const bgColor = useColorModeValue("white", "black");

  const closeModal = useCallback(() => {
    onClose();
    onClosed && onClosed();
  }, [onClose, onClosed]);

  useEffect(() => {
    if (ns !== undefined) {
      onOpen();
    }
  }, [ns, onOpen]);

  return (
    <>
      {ns !== undefined && <>
        <Modal
          isOpen={isOpen}
          onClose={closeModal}
          size="2xl"
          scrollBehavior="inside"
        >
          <ModalOverlay backdropFilter="auto" backdropBlur="5px" backdropBrightness="95%" />
          <ModalContent>
            <ModalHeader
              borderTopStartRadius={6}
              borderTopEndRadius={6}
            >
              <Stack direction="row" alignItems="baseline" justifyContent="space-between" spacing={3} mr={8}>
                <Stack direction="row" spacing={2} alignItems="center">
                  {
                    name
                    ? <>
                      <Text fontSize="2xl" fontWeight="normal" pl={2}>
                        {intl.formatMessage({
                          id: "alarms__alarm_ns__group_title",
                          defaultMessage: "Settings of alarms group",
                        })}
                      </Text>
                      <Text fontSize="2xl" fontWeight="bold" title={intl.formatMessage({
                        id: "alarms__alarm_ns__title",
                        defaultMessage: "Alarms group name",
                      })}>
                        {name}
                      </Text>
                    </>
                    : <>
                      <Text fontSize="2xl" fontWeight="normal" pl={2}>
                        {intl.formatMessage({
                          id: "alarms__alarm_ns__all_groups_title",
                          defaultMessage: "Settings of all alarms",
                        })}
                      </Text>
                    </>
                  }
                </Stack>
              </Stack>
            </ModalHeader>

            <ModalCloseButton title={intl.formatMessage({
              id: "alarms__alarm_ns__detail_close",
              defaultMessage: "Close alarms group detail",
            })} />

            <ModalBody>

              <Stack direction="column" spacing={6}>
                <Stack direction="row" flexGrow={1}>
                  <AlarmRules
                    siteId={siteId}
                    namespace={ns || undefined}
                    textColor={textColor}
                    bgColor={bgColor}
                    flexGrow={1}
                    flexBasis="40%"
                    spacing={3}
                  />
                </Stack>
              </Stack>

            </ModalBody>
            <ModalFooter>


            </ModalFooter>
          </ModalContent>
        </Modal>
      </>}
    </>
  );
};

export default AlarmGroupDetail;
